/* RESPONSIBLE TEAM: team-workflows */
import type CustomObjectSelector from 'embercom/models/operator/visual-builder/step/custom-object-selector';
import StepConfig, { type StepConfigParams } from '../step';

export default class CustomObjectSelectorConfiguration extends StepConfig {
  declare step: CustomObjectSelector;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/custom-object-selector',
      ...params,
    });
  }
}
